import React, {useEffect, useRef} from "react";
import { Link } from "react-router-dom";

const Conversation = ({messages, formatTime, selectedUser, isMsgLoading}) => {
   const messagesRef = useRef(null);
    useEffect(() => {
        scrollToBottom();
    }, [messages, selectedUser]);

    const scrollToBottom = () => {
        messagesRef.current?.scrollIntoView({ behavior: "smooth" });
    };

  return (
    <>
      <div className="messages-container">
        {isMsgLoading ? (
          <p className="text-center">Loading....</p>
        ):(
<>
        {messages.map((message, index) => (
          <div
            key={message._id || message.id || index}
            className={`message ${
             message.isStaffMessage === true || message.sender === "pillpharm" ? "sent" : "received"
            }`}
          >
            <div className="message-content">
              {message.orderIdLabel && (
                <p className="message-time" style={{ marginBottom: "6px" }}>
                  Order:{" "}
                  {message.order ? (
                    <Link to={`/orders/${message.order}`}>{message.orderIdLabel}</Link>
                  ) : (
                    message.orderIdLabel
                  )}
                </p>
              )}
              <p>{message.body}</p>
              {message.media && message.media.length > 0 && (
                <div className="media-preview">
                  {message.media.map((url, index) => (
                    <img
                      key={index}
                      src={url}
                      alt={`media-${index}`}
                      style={{
                        maxWidth: "200px",
                        maxHeight: "200px",
                        margin: "5px",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                    />
                  ))}
                </div>
              )}
              <div className="message-time">
                {formatTime(message.creationDate)}
                {(message.isStaffMessage === true || message.sender === "pillpharm") && (
                  <span className={`status`}>✓</span>
                )}
                {message.isStaffMessage !== true && message.sender !== "pillpharm" && message.read && (
                  <span className={`status text-danger`}>✓</span>
                )}
              </div>
            </div>
          </div>
        ))}
        <div ref={messagesRef} />
</>
        )}

      </div>
    </>
  );
};

export default Conversation;
